<template>
  <div>
    <el-container class="layout-root">
      <el-header :style="{ display: isHeaderShow ? 'block' : 'none' }">
        <NavHeader></NavHeader>
      </el-header>

      <el-container>
        <el-aside width="200px" :style="{ display: isAsideShow ? 'block' : 'none' }">
          <NavAside></NavAside>
        </el-aside>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'APP',
  computed: {
    ...mapState('m_tabs', ['isAsideShow', 'isHeaderShow'])
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

* {
  margin: 0;
  padding: 0;
  /* 內减模式 */
  box-sizing: border-box;
  font-size: 14px;
}

/* 去掉菜单样式 */
li {
  list-style: none;
}

/* 去掉a标签的下划线 */
a {
  text-decoration: none;
}

body {
  background-color: #f5f7fa;
}

// elementui 定制

.el-header,
.el-aside {
  background-color: #fff;
}

// html, body {
//   overflow: hidden; /* 彻底裁掉超出部分，滚动条消失，且无法滚动 */
//   height: 100%;    /* 确保高度只占满一屏 */
// }

.el-table .caret-wrapper {
  visibility: hidden;
}

.el-table th.el-table__cell:hover .caret-wrapper,
.el-table th.el-table__cell.ascending .caret-wrapper,
.el-table th.el-table__cell.descending .caret-wrapper {
  visibility: visible;
}

/* 案件详情表格居中样式 */
.printable-a4 {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.table {
  margin-left: auto !important;
  margin-right: auto !important;
  margin-bottom: 20px;
}

/* 确保表格容器也居中 */
#print-detail,
#print-fangan,
#print-jindu,
#print-files,
#print-wenshu {
  display: flex;
  justify-content: center;
}
</style>